exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.tooltip_content__tooltip-content--2XeTD {\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\toverflow: hidden;\n\tpadding: 7px 5px;\n\ttext-align: left\n}\n\n.tooltip_content__tooltip-content--single-line--3d2Vd {\n\t\twhite-space: nowrap;\n\t}\n\n.tooltip_content__tooltip-content-title--2Cr7A {\n\t\tfont-family: 'avenirheavy', Helvetica, Arial, sans-serif;\n\t}\n\n", ""]);

// exports
exports.locals = {
	"tooltip-content": "tooltip_content__tooltip-content--2XeTD",
	"tooltip-content--single-line": "tooltip_content__tooltip-content--single-line--3d2Vd",
	"tooltip-content-title": "tooltip_content__tooltip-content-title--2Cr7A"
};